export const PlayPauseIcon = ({ className = "h-5 w-5" }: { className?: string }) => {
  return (
    <svg 
      viewBox="0 0 100 100" 
      fill="currentColor"
      className={className}
    >
      {/* Play triangle */}
      <path d="M20,15 L20,50 L45,32.5 Z" />
      {/* Pause bars */}
      <rect x="55" y="15" width="8" height="35" />
      <rect x="72" y="15" width="8" height="35" />
      {/* Registration/enrollment icon at bottom */}
      <rect x="15" y="60" width="70" height="25" rx="3" />
      <circle cx="30" cy="72.5" r="5" fill="white" />
      <circle cx="50" cy="72.5" r="5" fill="white" />
      <circle cx="70" cy="72.5" r="5" fill="white" />
    </svg>
  );
};
